import { triggerLogout } from "core/authentication/auth-context";
import { toast } from "react-toastify";
import { loginService } from "services";
import { UI_URL } from "shared/urls.constant";

const handleResponse = (response) => {
  if (response.config?.getResponseHeaders) {
    response.data.headers = response.headers;
  }

  return response;
};

/**
 * Retry request
 * @param {*} response
 * @param {*} httpClient
 * @returns {Promise<any>} response
 */
const retry = async (response, httpClient) => {
  const retry = response?.config?.retry;
  if (
    retry &&
    retry.retries > 0 &&
    typeof retry.retryCondition === "function" &&
    retry.retryCondition(response)
  ) {
    return new Promise((resolve) => {
      setTimeout(() => {
        retry.retries -= 1;
        httpClient.request(response.config).then(resolve);
      }, retry.retryDelay);
    });
  } else {
    // No need to do anything, take rest
    return response;
  }
};

export const handleResponseError = (error, httpClient) => {
  if (
    (error.status === 401 || error.status === 498 || error.search === 998) &&
    !loginService.logoutInProgress
  ) {
    loginService.logoutInProgress = true;
    loginService.clearLoginData();
    localStorage.removeItem("token");
    localStorage.removeItem("appConfig");
    triggerLogout();
    toast.error("Session has expired. Please login again!", {
      autoClose: 2000,
      onClose: () => {
        //navigate(UI_URL.LOGIN);
         window.location.pathname = UI_URL.LOGIN;
      },
    });
  }
  return error;
};

const responseInterceptors = [retry, handleResponse];
export default responseInterceptors;
